import { AFFILIATE_QUERY } from '@gig/magic-messages';

class AffiliateService {
  constructor(cookie) {
    this.cookie = cookie;
    this.registerAffiliateQuery();
  }
  getAffiliateTag() {
    return this.cookie.read("btag");
  }
  setAffiliate(btag) {
    const nextMonth = new Date();
    nextMonth.setTime(nextMonth.getTime() + 1e3 * 60 * 60 * 24 * 30);
    this.cookie.write("btag", btag, { expires: nextMonth });
    this.affiliateTag = btag;
  }
  registerAffiliateQuery() {
    window.queryBus.subscribe(AFFILIATE_QUERY, () => {
      return this.affiliateTag;
    });
  }
}

export { AffiliateService };
